import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import WarningIcon from "@material-ui/icons/Warning";

import Button from "../../../components/CustomButtons/Button.js";
import ModalHeader from "../../../components/ModalHeader";

const useStyles = makeStyles(() => ({
  intro: { fontSize: "13.5px", color: "#3C4858", marginBottom: "12px" },
  warnRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#b45c00",
    fontWeight: 500,
    marginBottom: "10px",
  },
  list: {
    maxHeight: "45vh",
    overflowY: "auto",
    margin: 0,
    paddingLeft: 0,
    listStyle: "none",
  },
  item: {
    padding: "7px 0",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
    fontSize: "12.5px",
  },
  user: { fontWeight: 600, color: "#3C4858" },
  perms: { color: "#b45c00", marginLeft: "6px" },
}));

/**
 * Confirmacao de 2-step ao CONCEDER permissoes marcadas como perigosas.
 * ``grants`` = [{ userName, permLabels: [string] }].
 */
export default function ConfirmDangerousDialog({
  open,
  grants,
  onConfirm,
  onCancel,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <ModalHeader
        title={t("access_management.confirm.title")}
        onClose={onCancel}
      />
      <DialogContent>
        <div className={classes.warnRow}>
          <WarningIcon fontSize="small" />
          {t("access_management.confirm.heading")}
        </div>
        <div className={classes.intro}>
          {t("access_management.confirm.intro")}
        </div>
        <ul className={classes.list}>
          {grants.map((g, idx) => (
            <li key={idx} className={classes.item}>
              <span className={classes.user}>{g.userName}</span>
              <span className={classes.perms}>{g.permLabels.join(", ")}</span>
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="gray" simple>
          {t("access_management.cancel")}
        </Button>
        <Button onClick={onConfirm} color="client">
          {t("access_management.confirm.confirm_btn")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDangerousDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  grants: PropTypes.array.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
